module.exports = __webpack_public_path__ + "img/SVERDL.85a6954c.png";